import { useLocation, useNavigate } from "react-router-dom";

const useGoBack = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (fallbackUrl: string) => {
    if (location.key === "default") void navigate(fallbackUrl);
    else void navigate(-1);
  };
};

export default useGoBack;
